export function fixProductTaxons (product) {
  // expected
  // {
  //   "main": "taxon1",
  //   "others": [
  //     "taxon2"
  //   ],
  //   "othersWithSort": [
  //     {
  //       "taxon": "taxon3",
  //       "pos": 4
  //     }
  //   ]
  // }
  product.taxonsSort = {}
  if (product.taxons && !(product.taxons instanceof Array)) {
    product.taxons = Object.values(product.taxons)
      .reduce((p, c) => c instanceof Array ? p.concat(c) : p.concat([c]), [])
      .map(v => {
        if (typeof v === 'object') {
          product.taxonsSort[v.taxon] = v.pos
          v = v.taxon
        }
        return v
      })
  }
  return product
}

export function fixTaxon (taxon, parentCode = null) {
	const image = taxon.images[0];
	const headerImage = taxon.images.find(image => image.code == 'category_header');

	return {
		...taxon,
		parentCode,
		image: image ? image.path : '',
		headerImage: headerImage ? headerImage.path : image ? image.path : '',
		children: taxon.children.map(childTaxon => {
			return fixTaxon(childTaxon, taxon.code)
		})
	}
}

export function fixProduct(c) {
	const image = c.images.find(image => image.code == 'shopmanager_product');
	const imageSpecial = c.images.find(image => image.code == 'shopmanager_product_special');
	const imageMood = c.images.find(image => image.code == 'shopmanager_product_mood');
	const imagesDetail = c.images.filter(image => image.code == 'shopmanager_product_detail');

	fixProductTaxons(c)

	return {
		tags: c.attributes?.reduce((p, c) => {
			if (c.code == "tags") {
				//TODO: we can remove this check in a future version
				if (!(c.value instanceof Array)) {
					throw new Error("productlist::readTags deprecated API")
				}
				p = p.concat(
					c.value.map(v => v["key"])
				)
			}
			return p
		}, []) || [],
		// add default stock
		stock: -1,
		dishEnabled: false,
		discountInPercent: true,
		averageRatings: 0,
		...c,

		image: image ? image.path : c.images.length && c.images[0].path || '',
		imageSpecial: imageSpecial ? imageSpecial.path : imagesDetail.length ? imagesDetail[0].path : '',//image ? image.path : c.images.length && c.images[0].path || '',
		imageMood: imageMood ? imageMood.path : '',
		imagesDetail: imagesDetail.length ? imagesDetail.map(i => i.path) : [image ? image.path : c.images.length && c.images[0].path || ''],

		originalPrice: c.originalPrice?.current,
		price: c.price?.current,

		variants: c.variants?.map(variant => {
			return {
				...variant,
				originalPrice: variant.originalPrice?.current,
				price: variant.price?.current,
				stock: variant.stock == null ? -1 : variant.stock
			}
		}) || []
	}
}